export const MAX_MAP_PREVIEW_FIELDS_LIMIT = 5;
export const MAP_RECORDS_PAGE_SIZE = 50;

export const LASSO_SELECTIONS_LIMIT = 1000;

export const MAP_RECORD_LIST_SCROLL_KEY = "MAP_ENTITIES";

export const MILEAGE_TRACKING_UPSELL_URL = "https://share.hsforms.com/1VRulM5fhTvmNRxQAMKtaQg3is1h";
